import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useAuth } from '../../../app/hooks/useAuth'
import { format } from 'date-fns'
import { useEffect } from 'react'
import { formatAccountAndAgency } from '../../../app/utils/formatAccountAndAgency'
import { formatPhoneNumber } from '../../../app/utils/formatPhoneNumber'
import { formatZipCode } from '../../../app/utils/formatZipCode'

const schema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  birthDate: z.string().optional(),
  address: z.object({
    zipCode: z.string().optional(),
    state: z.string().optional(),
    city: z.string().optional(),
    neighborhood: z.string().optional(),
    street: z.string().optional(),
    number: z.string().optional(),
    complement: z.string().optional(),
  }),
  bankAccount: z.object({
    bank: z.string().optional(),
    agency: z.string().optional(),
    account: z.string().optional(),
    accountType: z.string().optional(),
    pixKey: z.string().optional(),
    pixType: z.string().optional(),
  }),
  commissionRate: z.coerce.number().optional(),
})

export type FormUserData = z.infer<typeof schema>

export const usePerfil = () => {
  const methods = useForm<FormUserData>({
    resolver: zodResolver(schema),
  })

  const { user } = useAuth()

  const { reset } = methods

  useEffect(() => {
    if (user) {
      reset({
        ...user,
        birthDate: user.birthDate
          ? format(user.birthDate, 'dd/MM/yyyy')
          : undefined,
        phone: formatPhoneNumber(user.phone),
        address: {
          ...user.address,
          zipCode: user?.address?.zipCode
            ? formatZipCode(user.address.zipCode)
            : undefined,
        },
        bankAccount: {
          ...user.bankAccount,
          account: user?.bankAccount?.account
            ? formatAccountAndAgency(user.bankAccount.account)
            : undefined,
        },
      })
    }
  }, [reset, user])

  return {
    user,
    methods,
  }
}
